import { directionsUrl } from './calendarLinks';
import { easternDateTime, formatKickoff } from './kickoff';

const TIMEZONE = 'America/New_York';
const GAME_WINDOW_MS = 3 * 60 * 60 * 1000;

const formatTime = (date, time) => formatKickoff(easternDateTime(date, time));
const formatDay = (date) => new Date(`${date}T12:00:00`).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
export const easternToday = (now = new Date()) => new Intl.DateTimeFormat('en-CA', { timeZone: TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);

export const reminderPhase = (game, now = new Date()) => {
  if (!game?.date || game.sessionType !== 'game' || game.result) return null;
  const kickoff = easternDateTime(game.date, game.endTime || game.startTime);
  if (!kickoff || now - kickoff > GAME_WINDOW_MS) return null;
  const today = easternToday(now);
  if (today === game.date) return 'today';
  const eveBefore = new Date(kickoff);
  eveBefore.setDate(eveBefore.getDate() - 1);
  return today === easternToday(eveBefore) ? 'tomorrow' : null;
};

export const reminderText = (game, weather) => {
  const title = (game.notes || '').split('·')[0].trim() || `Brookline JP Patriots vs ${game.opponent || 'opponent'}`;
  const lines = [
    `GAME DAY REMINDER — ${title}, ${formatDay(game.date)}.`,
    `Report ${formatTime(game.date, game.startTime)}${game.endTime ? ` · Kickoff ${formatTime(game.date, game.endTime)}` : ''} · ${game.location}.`,
    `Directions: ${directionsUrl(game.location)}`,
  ];
  if (weather?.temperature_f != null) lines.push(`Forecast at kickoff: ${weather.temperature_f}°, ${weather.precipitation_probability_percent}% rain — ${weather.packing_hint}.`);
  lines.push('Go Patriots!');
  return lines.join('\n');
};

export const reminderSmsHref = (game, weather) => `sms:?&body=${encodeURIComponent(reminderText(game, weather))}`;
